/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */

import CourseSchedule from './CourseSchedule';

/**
 * CourseSchedule module exports
 */
export { CourseSchedule as default };



// WEBPACK FOOTER //
// ./src/js/Cards/components/CourseSchedule/index.js